import React from 'react'
import Depos from './depos'

export default function Deposit() {
  return (
    <>
      <Depos />
    </>
  )
}
